<template>
	<div style="margin-top: auto; margin-bottom: auto">
		<v-btn x-small fab icon color="primary" @click="getProviders(true)" :loading="loadingProviders">
			<v-icon small>mdi-store</v-icon>
		</v-btn>
		<v-dialog v-model="showProvidersFilter" width="50%" scrollable>
			<v-card>
				<v-card-title class="title primary--text mb-2 secondary">
					<v-icon class="mr-1" color="primary">mdi-store</v-icon>
					<translate>Filter Providers</translate>
				</v-card-title>
				<v-card-text>
					<p
						v-if="allProviders.length == 0"
						class="grey--text my-3"
						v-translate
					>
						No providers.
					</p>
					<v-list v-else flat>
						<v-list-item-group>
							<v-list-item
								v-for="provider in allProviders"
								:key="provider.id"
								style="border: 1px solid #e0e0e0; border-radius: 5px"
								@click="selectProvider(provider)"
							>
								<v-list-item-icon class="mr-3">
									<v-icon color="primary">mdi-store</v-icon>
								</v-list-item-icon>
								<v-list-item-content>
									<v-list-item-title>
										<strong>{{ provider.name }}</strong>
									</v-list-item-title>
								</v-list-item-content>
								<v-list-item-action>
									<v-row no-gutters align="center">
										<v-checkbox
											@click="selectProvider(provider)"
											v-model="provider.selected"
											color="primary"
										></v-checkbox>
									</v-row>
								</v-list-item-action>
							</v-list-item>
						</v-list-item-group>
					</v-list>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-btn color="primary" text @click="showProvidersFilter = false">
						<translate>Cancel</translate>
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn
						color="primary"
						text
						@click="saveProviderFilters"
						:loading="savingProviders"
					>
						<translate>Save</translate>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import axios from "axios";

export default {
	name: "FilterProviders",
	data: () => ({
		allProviders: [],
		showProvidersFilter: false,
    loadingProviders: false,
		savingProviders: false
	}),
	methods: {
		saveProviderFilters() {
			this.savingProviders = true;
			let excluded_providers = this.allProviders.filter((p) => !p.selected);
			axios
				.post("/filter-providers", excluded_providers)
				.then((response) => {
					console.log(response.data);
          this.$emit('filtered-providers', response.data);
					this.showProvidersFilter = false;
					this.savingProviders = false;
				})
				.catch((error) => {
					console.log(error);
					this.savingProviders = false;
				});
		},
		selectProvider(provider) {
			provider.selected = !provider.selected;
		},
		getProviders() {
      this.loadingProviders = true;
			axios
				.get("/providers", { params: { all: true } })
				.then((response) => {
					console.log(response.data);
					this.allProviders = response.data;
					this.showProvidersFilter = true;
          this.loadingProviders = false;
				})
				.catch((error) => {
					console.log(error);
          this.loadingProviders = false;
				});
		},
	},
};
</script>